// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"PageToolbar_toolbar__e07K_","leading":"PageToolbar_leading__3OLIj","actions":"PageToolbar_actions__2-KLk"};